import { render, staticRenderFns } from "./PeriodOfConstructionFormStep.vue?vue&type=template&id=46fd7372"
import script from "./PeriodOfConstructionFormStep.vue?vue&type=script&lang=js"
export * from "./PeriodOfConstructionFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports